var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { memo, useRef, useState } from 'react';
import { Button } from '../Button/Button';
import { CrossIcon } from '../SearchBox/Icons';
import FilesDragAndDrop from './FilesDragAndDrop/FilesDragAndDrop';
import { InputIconError } from '../Input/InputIconError/InputIconError';


var FilePickerArea = memo(function (_a) {
    var className = _a.className, acceptedFileFormats = _a.acceptedFileFormats, error = _a.error, onChange = _a.onChange, value = _a.value, loading = _a.loading, _b = _a.uploadButtonLabel, uploadButtonLabel = _b === void 0 ? 'Browse and upload logo image' : _b, _c = _a.replaceLabel, replaceLabel = _c === void 0 ? 'Replace' : _c, _d = _a.invalidFileFormatErrorLabel, invalidFileFormatErrorLabel = _d === void 0 ? 'Invalid file format' : _d, disabled = _a.disabled, children = _a.children, instructions = _a.instructions, hoverText = _a.hoverText;
    var _e = useState(null), dragAndDropError = _e[0], setDragAndDropError = _e[1];
    var inputRef = useRef(null);
    var classNames = ['pluggy', 'FilePickerArea'];
    if (className) {
        classNames.push(className);
    }
    if (value) {
        classNames.push('filled');
    }
    if (error || dragAndDropError) {
        classNames.push('error');
    }
    if (disabled) {
        classNames.push('disabled');
    }
    if (loading) {
        classNames.push('loading');
    }
    var handleChange = React.useCallback(function (_a) {
        var files = _a.target.files;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!files || files.length === 0) {
                    // if user cancels file selection, don't set selected file to null
                    return [2 /*return*/];
                }
                onChange === null || onChange === void 0 ? void 0 : onChange(files[0]);
                setDragAndDropError(null);
                return [2 /*return*/];
            });
        });
    }, [onChange]);
    var handleButtonClick = React.useCallback(function () {
        var _a;
        if (!inputRef.current) {
            return;
        }
        // open the file picker
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    var handleClearSelectedFile = React.useCallback(function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
        setDragAndDropError(null);
    }, [onChange]);
    return (React.createElement(FilesDragAndDrop, { onUpload: onChange, acceptedFileFormats: acceptedFileFormats, onError: function (error) { return setDragAndDropError(error); }, invalidFileFormatErrorLabel: invalidFileFormatErrorLabel, disabled: disabled, hoverText: hoverText },
        React.createElement("div", { className: classNames.join(' ') },
            React.createElement("div", { className: 'instructions' }, instructions),
            error || dragAndDropError ? (React.createElement("div", { className: 'upload-error' },
                React.createElement("div", { className: 'icon' },
                    React.createElement(InputIconError, { size: 16 })),
                dragAndDropError || error,
                React.createElement(Button, { link: true, onClick: handleButtonClick, disabled: disabled }, replaceLabel))) : value ? (React.createElement("div", { className: 'uploaded-file' },
                React.createElement("div", { className: 'uploaded-file-name' }, value.name),
                React.createElement("div", { className: 'uploaded-file-clear' },
                    React.createElement(CrossIcon, { onClear: handleClearSelectedFile, className: disabled ? 'disabled' : '' })))) : (React.createElement(Button, { onClick: handleButtonClick, disabled: disabled, size: 'small' }, uploadButtonLabel)),
            children,
            React.createElement("input", { type: 'file', ref: inputRef, className: 'hidden-input', onChange: handleChange, accept: acceptedFileFormats && acceptedFileFormats.join(',') }))));
});
export { FilePickerArea };
